import { Box, Typography } from '@mui/material'
import { ReactNode } from 'react'
import UnitAdornment from './UnitAdornment'

interface Props {
  label: ReactNode
  value: ReactNode
  unit?: ReactNode
}
function HistoryItemField ({ label, value, unit }: Props) {
  return (
    <Box className="flex flex-col gap-2 min-w-[8rem]">
      <Typography
        fontSize="0.8rem"
        fontWeight="bold"
      >
        {typeof label === 'number'
          ? label.toLocaleString()
          : label}
      </Typography>
      <Box className="flex">
        <span>{value}</span>
        {unit && (
          <UnitAdornment unit={unit} />
        )}
      </Box>
    </Box>
  )
}

export default HistoryItemField
